module.exports = __webpack_public_path__ + "img/Checkbox unselected Icon - charcoal.ee350edc.svg";